var _circle, _path, _circle2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCollaborate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48.286mm",
    height: "48.286mm",
    viewBox: "0 0 48.286 48.286",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-105.7 -141.93)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 129.85,
    cy: 166.08,
    r: 24.143,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m129.85 148.79c-7.5118 0-14.308 5.759-14.308 14.666 0 5.9379 4.7754 12.967 14.308 21.104 9.5328-8.1377 14.308-15.167 14.308-21.104 0-8.9069-6.7964-14.666-14.308-14.666zm-0.16771 14.029c-1.9674 0 0.25153 2.149 0.25153 0.1818 0-1.9673-2.0093-0.027-0.0419-0.027 1.9674 0 0.0142-1.9534 0.0142 0.014s1.7438-0.1676-0.22354-0.1676z",
    fill: "#f1d669",
    strokeWidth: 1.7885
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 129.85,
    cy: 163.03,
    r: 13.295,
    fill: "#f8ebb5"
  })), /*#__PURE__*/React.createElement("text", {
    x: 136.58821,
    y: 160.189,
    fill: "#4a5f72",
    fontFamily: "sans-serif",
    fontSize: "15.014px",
    fontWeight: "bold",
    strokeWidth: 0.37536,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 136.58821,
    y: 160.189,
    fill: "#4a5f72",
    fontFamily: "sans-serif",
    fontSize: "15.014px",
    fontWeight: "bold",
    strokeWidth: 0.37536,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }, "+"))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollaborate);
export default __webpack_public_path__ + "static/media/collaborate.c201bdd7a1f5d48781ffa4e55150c16b.svg";
export { ForwardRef as ReactComponent };